import ProAgeBanner from "./components/banner/index.vue";
import ProAgeProgram from "./components/program/index.vue";
import ProAgeWhatYouGet from "./components/what-you-get/index.vue";
import ProAgeFormat from "./components/format/index.vue";
import ProAgeImage from "./components/image/index.vue";
import ProAgeEvents from "./components/events/index.vue";
import ProAgeEvent from "./components/event/index.vue";
import ProAgeList from "./components/list/index.vue";
import ProAgePractice from "./components/practice/index.vue";
import dynamicsHead from "@/mixins/dynamics-head";
import { globalLoader } from "@/helpers/variables";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ProAgePage",
  components: {
    ProAgeBanner,
    ProAgeProgram,
    ProAgeWhatYouGet,
    ProAgeFormat,
    ProAgeImage,
    ProAgeEvents,
    ProAgeList,
    ProAgeEvent,
    ProAgePractice
  },
  data() {
    return {};
  },
  mixins: [dynamicsHead],
  async created() {
    globalLoader(true);
    await Promise.all([this.fetchProAgeCode(), this.fetchTickets()]);

    this.setPageMetaInfo(this.content);
  },
  computed: {
    ...mapGetters({
      content: "proAge/content",
    }),
  },
  methods: {
    ...mapActions({
      fetchProAgeCode: "proAge/FETCH_PRO_AGE_CODE",
      fetchTickets: "proAge/FETCH_TICKETS",
    }),
  },
};
